var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"view-selector",class:{ active: _vm.isActiveView },on:{"click":function($event){return _vm.$emit('setActiveViewName')}}},[_vm._v("\n  "+_vm._s(_vm._f("t")(_vm.view.title))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }